import { Directive, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[cusInnerHTML]'
})
export class CusInnerHTMLDirective {
  selElement: HTMLElement;
  @Input() set cusInnerHTML(content: string) {
    this.selElement.innerHTML = content;
  }
  constructor(private _renderer: Renderer2, public _ref: ElementRef) {
    this.selElement = this._ref.nativeElement;
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/directs/cus-inner-html.directive.ts